(function () {
  function initReviews(root) {
    if (root.__sprInit) return;
    root.__sprInit = true;

    var list = root.querySelector('.spr-list');
    var items = Array.prototype.slice.call(root.querySelectorAll('.spr-review'));
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 5;
    var pagination = root.querySelector('.spr-pagination');
    var sortWrap = root.querySelector('.spr-sort');
    var sortToggle = root.querySelector('.spr-sort__toggle');
    var sortPanel = root.querySelector('.spr-sort__panel');
    var sortOptions = Array.prototype.slice.call(root.querySelectorAll('.spr-sort__option'));
    var currentSort = root.getAttribute('data-default-sort') || 'featured';
    var currentPage = 1;

    function comparator(sort) {
      return function (a, b) {
        var order = parseInt(a.getAttribute('data-order'), 10) - parseInt(b.getAttribute('data-order'), 10);
        if (sort === 'recent') {
          var ta = parseInt(a.getAttribute('data-timestamp'), 10) || 0;
          var tb = parseInt(b.getAttribute('data-timestamp'), 10) || 0;
          return tb - ta || order;
        }
        if (sort === 'photos') {
          var pa = parseInt(a.getAttribute('data-has-photo'), 10);
          var pb = parseInt(b.getAttribute('data-has-photo'), 10);
          return pb - pa || order;
        }
        if (sort === 'rating-desc') {
          var ra = parseInt(a.getAttribute('data-rating'), 10);
          var rb = parseInt(b.getAttribute('data-rating'), 10);
          return rb - ra || order;
        }
        if (sort === 'rating-asc') {
          var ra2 = parseInt(a.getAttribute('data-rating'), 10);
          var rb2 = parseInt(b.getAttribute('data-rating'), 10);
          return ra2 - rb2 || order;
        }
        return order;
      };
    }

    function applySort() {
      items.sort(comparator(currentSort));
      items.forEach(function (el) {
        list.appendChild(el);
      });
    }

    function renderPage() {
      var total = items.length;
      var totalPages = Math.max(1, Math.ceil(total / perPage));
      if (currentPage > totalPages) currentPage = totalPages;

      var start = (currentPage - 1) * perPage;
      var end = start + perPage;

      items.forEach(function (el, index) {
        el.hidden = index < start || index >= end;
      });

      renderPagination(totalPages);
    }

    function renderPagination(totalPages) {
      if (!pagination) return;
      pagination.innerHTML = '';

      if (totalPages <= 1) {
        pagination.hidden = true;
        return;
      }
      pagination.hidden = false;

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'spr-page-btn';
      prev.setAttribute('aria-label', 'Page précédente');
      prev.innerHTML =
        '<svg viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.84 2.066V1.031c0-.09-.104-.14-.173-.084L.629 5.662a.427.427 0 0 0 0 .674l6.038 4.716a.107.107 0 0 0 .173-.085V9.932a.217.217 0 0 0-.082-.169L1.936 6l4.822-3.765a.217.217 0 0 0 .082-.169z" fill="currentColor"/></svg>';
      prev.disabled = currentPage === 1;
      prev.addEventListener('click', function () {
        currentPage -= 1;
        renderPage();
        scrollToTop();
      });
      pagination.appendChild(prev);

      for (var i = 1; i <= totalPages; i++) {
        (function (page) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'spr-page-btn' + (page === currentPage ? ' is-active' : '');
          btn.textContent = page;
          btn.addEventListener('click', function () {
            currentPage = page;
            renderPage();
            scrollToTop();
          });
          pagination.appendChild(btn);
        })(i);
      }

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'spr-page-btn';
      next.setAttribute('aria-label', 'Page suivante');
      next.innerHTML =
        '<svg viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.398 5.663L.36.947a.107.107 0 0 0-.172.085v1.035c0 .065.03.128.081.169L5.091 6 .269 9.765a.213.213 0 0 0-.081.169v1.035c0 .09.103.14.172.084l6.038-4.715a.428.428 0 0 0 0-.675z" fill="currentColor"/></svg>';
      next.disabled = currentPage === totalPages;
      next.addEventListener('click', function () {
        currentPage += 1;
        renderPage();
        scrollToTop();
      });
      pagination.appendChild(next);
    }

    function scrollToTop() {
      var top = root.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    function setActiveOption(sort) {
      sortOptions.forEach(function (opt) {
        opt.classList.toggle('is-active', opt.getAttribute('data-sort') === sort);
      });
    }

    function closeSort() {
      sortPanel.classList.remove('is-open');
      sortToggle.setAttribute('aria-expanded', 'false');
    }

    if (sortToggle && sortPanel) {
      sortToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = sortPanel.classList.toggle('is-open');
        sortToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });

      sortOptions.forEach(function (opt) {
        opt.addEventListener('click', function () {
          currentSort = opt.getAttribute('data-sort');
          setActiveOption(currentSort);
          currentPage = 1;
          applySort();
          renderPage();
          closeSort();
        });
      });

      document.addEventListener('click', function (e) {
        if (!sortWrap.contains(e.target)) closeSort();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSort();
      });
    }

    var lightbox = root.querySelector('.spr-lightbox');
    if (lightbox) {
      var lightboxImg = lightbox.querySelector('img');
      var lightboxClose = lightbox.querySelector('.spr-lightbox__close');

      root.addEventListener('click', function (e) {
        var trigger = e.target.closest('.spr-review__photo');
        if (!trigger) return;
        lightboxImg.src = trigger.getAttribute('data-full') || trigger.querySelector('img').src;
        lightbox.classList.add('is-open');
      });

      function closeLightbox() {
        lightbox.classList.remove('is-open');
        lightboxImg.src = '';
      }

      lightboxClose.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeLightbox();
      });
    }

    setActiveOption(currentSort);
    applySort();
    renderPage();
  }

  function placeMiniBadges() {
    document.querySelectorAll('.spr-mini-badge[hidden]').forEach(function (badge) {
      var selector = badge.getAttribute('data-target-selector');
      var target = selector && document.querySelector(selector);
      if (!target) return;
      target.appendChild(badge);
      badge.removeAttribute('hidden');
    });
  }

  function initAll() {
    document.querySelectorAll('.spr-reviews').forEach(initReviews);
    placeMiniBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector && event.target.querySelector('.spr-reviews');
    if (root) initReviews(root);
    placeMiniBadges();
  });
})();
